var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33329 1.33398H3.99996C3.64634 1.33398 3.3072 1.47446 3.05715 1.72451C2.8071 1.97456 2.66663 2.3137 2.66663 2.66732V13.334C2.66663 13.6876 2.8071 14.0267 3.05715 14.2768C3.3072 14.5268 3.64634 14.6673 3.99996 14.6673H12C12.3536 14.6673 12.6927 14.5268 12.9428 14.2768C13.1928 14.0267 13.3333 13.6876 13.3333 13.334V5.33398L9.33329 1.33398Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33337 1.33398V5.33398H13.3334",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12V8",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10H10",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFileIcon);
export default __webpack_public_path__ + "static/media/add_file_icon.7170be409c3cbe4bec8ee990ce33e6b2.svg";
export { ForwardRef as ReactComponent };